import { getTenantById } from '@tenants/manager';
import {
  ContentHostSelector,
} from '@tenants/types';

import type { TenantId } from '@tenants/types';

/**
 * Get the WordPress blog API URL for the given tenant.
 *
 * @param tenantId The {@link TenantId tenantId} to get the blog API URL for. Defaults to ZOOCASA_TENANT_ID
 * @returns The blog API URL for the given tenant.
 */
export const getBlogApiUrlForTenant = (tenantId: TenantId) => {
  const tenantConfig = getTenantById(tenantId);
  const blogApiUrl = tenantConfig?.blogApiUrl;
  return blogApiUrl;
};

/**
 * Get the WordPress content page URL for the given tenant.
 *
 * @param tenantId The {@link TenantId tenantId} to get the content page URL for.
 * @param locationSelector The {@link ContentHostSelector locationSelector} to get the content page URL for. Defaults to {@link ContentHostSelector.ALL ALL}.
 * @returns The content page URL for the given tenant.
 */
export const getContentPageUrlForTenant = (tenantId: TenantId, locationSelector: ContentHostSelector = 'ALL') => {
  const tenantConfig = getTenantById(tenantId);
  const contentHosts = tenantConfig?.contentHosts;

  return contentHosts[locationSelector];
};

export const getBlogContentPageUrlForTenant = (tenantId: TenantId) => {
  const tenantConfig = getTenantById(tenantId);
  const blogContentPageUrl = tenantConfig?.blogContentPageUrl;

  return blogContentPageUrl;
};
